export default function FormHeaderActions({
  onCancel,
  saving,
  copyPrice,
  isEditing,
  description,
  saveLabel = 'Guardar',
  disabled = false
}) {
  const headerText =
    description ||
    (isEditing
      ? 'Actualice los siguientes datos para editar la lista de precios ya existente:'
      : 'Ingrese los siguientes datos para crear una nueva lista de precio:')

  return (
    <div className="inline-block full-width">
      <div className="float-left">
        <h5>{headerText}</h5>
      </div>

      <div className="float-right">
        <button type="button" disabled={saving} className="cancel-button" onClick={onCancel}>
          Cancelar
        </button>

        <input
          disabled={saving || disabled}
          className="save-button"
          value={saving ? 'Guardando...' : saveLabel}
          type="submit"
        />
      </div>
    </div>
  )
}
